import { useState } from 'react';
import './FAQSection.css';

const faqs = [
  {
    q: 'What does settlor.money actually do?',
    a: 'We run payouts for businesses in India. You send money to your beneficiaries over IMPS, NEFT, RTGS and UPI through one API, and we handle the routing, the ledger and the reconciliation behind it. Banks, fintechs, lenders, marketplaces and enterprises all use us the same way.',
  },
  {
    q: 'Are you regulated by the RBI?',
    a: 'Yes. settlor.money operates as a Payment Aggregator under RBI guidelines, with full PMLA compliance and a published nodal officer for grievance redressal.',
  },
  {
    q: 'How long does the integration take?',
    a: 'Most integrations complete in 2–4 weeks from the kickoff call. Sandbox keys come through fast, and we provide an integration engineer throughout.',
  },
  {
    q: 'Do you have a partner program?',
    a: 'Yes, and the economics are written down on this page. We pay revenue share on referred merchants, with transparent terms and no lock-in.',
  },
  {
    q: 'Are your APIs idempotent and your webhooks signed?',
    a: 'Every payout request is idempotent via a client-supplied idempotency key. Every webhook is HMAC-signed so you can verify delivery authenticity.',
  },
  {
    q: 'Can I make payouts outside India?',
    a: 'Not currently. settlor.money is built for Indian payment rails — IMPS, NEFT, RTGS and UPI. International payouts are on the roadmap.',
  },
];

const PlusIcon = () => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15" cy="15" r="15" fill="#F3F3F3" />
    <path d="M15 11V19" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M11 15H19" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const CloseIcon = () => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15" cy="15" r="15" fill="#0043FE" />
    <path d="M12 12L18 18" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M18 12L12 18" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export default function FAQSection() {
  const [open, setOpen] = useState(0);

  return (
    <section className="faq">
      <div className="faq__inner">
        <div className="faq__left">
          <span className="faq__eyebrow">FAQ</span>
          <h2 className="faq__heading">Common questions</h2>
          <p className="faq__body">The questions teams ask us most. If yours is not here, email <a href="mailto:hello@settlor.money" className="faq__body-link">hello@settlor.money</a> and we will get you an answer.</p>
          <a href="#contact" className="faq__cta">Book a discovery call</a>
        </div>
        <div className="faq__list">
          {faqs.map((f, i) => (
            <div key={i} className={`faq__item${open === i ? ' faq__item--open' : ''}`}>
              <button className="faq__question" onClick={() => setOpen(open === i ? -1 : i)}>
                <span className="faq__question-text">{f.q}</span>
                <span className="faq__icon">{open === i ? <CloseIcon /> : <PlusIcon />}</span>
              </button>
              {open === i && (
                <div className="faq__answer">{f.a}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
